import {createErrorAction} from './utils';

const TYPES = {
    GET_AVERAGE_PLAY_TIME: 'GET_AVERAGE_PLAY_TIME',
    GET_AVERAGE_PLAY_TIME_COMPLETE: 'GET_AVERAGE_PLAY_TIME_COMPLETE',
    GET_AVERAGE_PLAY_TIME_FAILED: 'GET_AVERAGE_PLAY_TIME_FAILED',
    RESET_DATA: 'AVERAGE_PLAY_TIME_RESET_DATA'
};

export default {
    TYPES,

    getAveragePlayTime: payload => ({
        type: TYPES.GET_AVERAGE_PLAY_TIME,
        payload
    }),

    getAveragePlayTimeSuccess: payload => ({
        type: TYPES.GET_AVERAGE_PLAY_TIME_COMPLETE,
        payload
    }),

    getAveragePlayTimeFailed: createErrorAction(TYPES.GET_AVERAGE_PLAY_TIME_FAILED),

    resetData: () => ({
        type: TYPES.RESET_DATA
    })
};
